import React from "react";
import {ReactComponent as Locator} from "../../icons/Locator.svg";
import styles from "./LocatorIcon.module.scss"

export const LocatorIcon = () =>
    <span className={styles.wrapper}>
        <Locator/>
    </span>
